module.exports = "/fast-coin/img/coin/anim/in/coin_in_018.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/fast-coin/img/coin/anim/in/coin_in_018.png
// module id = 2288
// module chunks = 5